export default __webpack_public_path__ + "static/media/icon-insights-performance-feedback-handling.19826776.svg";